import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { EditorComponentBase, InputFormatterDirective } from 'ngx-lib';
import { ValidationErrorMessageComponent } from '../../validation-error-message/validation-error-message.component';

@Component({
    selector: 'app-custom-percentage-editor',
    templateUrl: './custom-percentage-editor.component.html',
    styleUrls: ['./custom-percentage-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, FormsModule, InputFormatterDirective, ValidationErrorMessageComponent]
})
export class CustomPercentageEditorComponent extends EditorComponentBase<number | null> implements OnInit {
    displayValue?: string | null;

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.displayValue =
            this.bindingProperty !== null && this.bindingProperty !== undefined
                ? (this.bindingProperty * 100).toFixed(2)
                : null;
    }

    dataChanged(event: string) {
        this.displayValue = event;
        this.bindingProperty = event !== null ? parseFloat(event) / 100 : null;
        this.valueChange.emit();
        this.validate();
    }
}
